<template>
  <div class="svg" v-html="require(`!html-loader!./../static/img/icon/${iconName}/default.svg`)"></div>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      required: true,
    },
  },
  mounted() {
    this.initSvg();
  },
  methods: {
    initSvg() {
      const svg = this.$el.firstChild;
      if (svg.getAttribute("fill") !== "none") {
        svg.setAttribute("fill", "currentColor");
      }
      svg.style.width = "100%";
      svg.style.height = "100%";
    },
  },
  watch: {
    iconName() {
      this.$nextTick(this.initSvg);
    },
  },
};
</script>

<style lang="scss" scoped>
.svg {
  width: 100%;
  height: 100%;
}
</style>
